// assets/scent-emoji.js
(function () {
  const mount = document.getElementById('scent-emoji-options');
  if (!mount || mount.dataset._sei === '1') return; mount.dataset._sei = '1';

  const norm = (s) => String(s ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

  // Product JSON
  const ps = document.querySelector('[id^="ProductJson-"]') ||
             document.querySelector('[id^="product-json-"]') ||
             document.querySelector('script[type="application/json"][data-product]');
  if (!ps) return;
  let product; try { product = JSON.parse(ps.textContent); } catch { return; }
  if (!product?.variants?.length) return;

  // Which option is scent?
  const scentIdx = (() => {
    const opts = product.options || [];
    let i = opts.findIndex(o => /scent|fragrance/i.test(String(o)));
    if (i === -1) i = opts.findIndex(o => norm(o) === 'choose your favorite scent');
    return i === -1 ? 0 : i;
  })();
  const scentValues = [...new Set(product.variants.map(v => String(v.options[scentIdx])))];

const STYLE = {
  'Unscented':       { emoji: '🧼', bg: '#ffe7e9', fg: '#111' },
  'Sicilian Lemon':  { emoji: '🍋', bg: '#fff7c7', fg: '#111' },
  'Espresso':        { emoji: '☕️', bg: '#eadfd5', fg: '#111' },
  'French Lavender': { emoji: '🪻', bg: '#efe8ff', fg: '#111' },

  // NEW SCENTS
  'Baby Powder':     { emoji: '🍼', bg: '#c4efff', fg: '#111' },
  'Sencha Green Tea':{ emoji: '🍃', bg: '#eaf6ea', fg: '#111' }
};


  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const forms = () => $$('product-form form, form[action*="/cart/add"]');

  // Find the scent group in a form (by legend/label)
  function findScentGroup(form) {
    const groups = $$('.product-form__input, .product-form__input--pill, fieldset', form);
    return groups.find(g => {
      const t = norm((g.querySelector('legend, label')?.textContent) || '');
      return t.includes('scent') || t.includes('fragrance') || t.includes('choose your favorite scent');
    }) || null;
  }

  // Read current scent from native radios
  function currentScentFromDOM() {
    for (const f of forms()) {
      const g = findScentGroup(f);
      if (!g) continue;
      const r = g.querySelector('input[type="radio"]:checked');
      if (r) return r.value;
    }
    return null;
  }

  // Click native scent radios in ALL forms (so pills + theme state update)
  function clickNativeScent(value) {
    const want = norm(value);
    forms().forEach(f => {
      const g = findScentGroup(f);
      if (!g) return;
      const radios = $$('input[type="radio"]', g);
      const target = radios.find(r => norm(r.value) === want);
      if (target) {
        target.checked = true;
        target.click();
        target.dispatchEvent(new Event('input',  { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
        f.dispatchEvent(new Event('change',      { bubbles: true }));
      }
    });
  }

  // Build tiles ONCE
  function buildOnce() {
    mount.innerHTML = '';
    const grid = document.createElement('div');
    grid.className = 'scent-emoji-grid';
    mount.appendChild(grid);

    const selectedNow = currentScentFromDOM();

    scentValues.forEach(val => {
      const st = STYLE[val] || { emoji: '🌿', bg: '#f3f3f7', fg: '#111' };
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'scent-tile';
      btn.dataset.value = val;
      btn.style.setProperty('--bg', st.bg);
      btn.style.setProperty('--fg', st.fg);
      btn.innerHTML = `<span class="scent-emoji">${st.emoji}</span><span class="scent-label">${val}</span>`;
      if (selectedNow && norm(selectedNow) === norm(val)) {
        btn.classList.add('is-selected');
      }
      grid.appendChild(btn);
    });
  }

  // Event delegation (survives DOM changes)
  mount.addEventListener('click', (e) => {
    const btn = e.target.closest('.scent-tile');
    if (!btn) return;
    const val = btn.dataset.value;

    // Immediate highlight
    mount.querySelectorAll('.scent-tile').forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    // Drive theme + variant
    window.__setScent && window.__setScent(val);
    clickNativeScent(val);
    window.__syncVariant && window.__syncVariant();
  });

  // Sync highlight when theme changes variant
  function syncHighlight() {
  const forms = Array.from(document.querySelectorAll('product-form form, form[action*="/cart/add"]'));

  // Permissive read of the checked scent radio
  let current = null;
  for (const f of forms) {
    // 1) by radio name
    const radios = Array.from(f.querySelectorAll('input[type="radio"]'))
      .filter(r => /scent|fragrance/i.test(String(r.name)));
    const checked = radios.find(r => r.checked);
    if (checked) { current = checked.value; break; }

    // 2) fallback: inside a group whose legend/label mentions scent
    const group = Array.from(f.querySelectorAll('.product-form__input, .product-form__input--pill, fieldset'))
      .find(g => /scent|fragrance|choose your favorite scent/i.test((g.querySelector('legend, label')?.textContent || '')));
    if (group) {
      const r = group.querySelector('input[type="radio"]:checked');
      if (r) { current = r.value; break; }
    }
  }

  // If nothing detected, keep whatever is currently highlighted
  if (!current) return;

  const norm = s => String(s ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
  document.getElementById('scent-emoji-options')
    ?.querySelectorAll('.scent-tile')
    .forEach(b => {
      b.classList.toggle('is-selected', norm(b.dataset.value) === norm(current));
    });
}

  document.addEventListener('variant:change', syncHighlight);
  document.addEventListener('shopify:section:load', syncHighlight);

  // Hardened periodic sync (handles any theme re-renders)
  if (!window.__scentSyncLoop) {
    window.__scentSyncLoop = setInterval(syncHighlight, 300);
  }

  buildOnce();
  syncHighlight();
})();
